import './TabView.scss'
import React, { useState } from "react";
import { TabPanel as PrTabPanel, TabView as PrTabView } from 'primereact/tabview';
import classNames from 'classnames'


function TabView({ className, data: innerTabData }) {
    const [activeIndex, setActiveIndex] = useState(0)

    const changeActiveTab = ({ index, originalEvent }) => {
        setActiveIndex(index)
    }

    return (
        <div>
            <PrTabView className={classNames('PrTabView', className)} activeIndex={activeIndex} onTabChange={changeActiveTab} >
                {innerTabData?.map((tab, i) => (
                    <PrTabPanel key={i} header={<div className="text-sm">{tab.label}</div>} disabled={tab.isDisabled} >
                        {tab.component}
                    </PrTabPanel>
                ))}
            </PrTabView>
        </div>
    )
}

export default TabView
